import { Network } from "@aptos-labs/ts-sdk";
import { TappSDK } from "../core";
import { SDKConfig } from "../types";

interface InitTappSDKConfig {
  network?: Network.MAINNET | Network.TESTNET;
  url?: string;
}

const TESTNET_CONFIG: SDKConfig = {
  network: Network.TESTNET,
  contractAddress:
    "0xc861148c940f4ac95e14a892fa971c745e93675fe3d76f4f398c88d5de46f0b9",
  url: "https://display-engine.dev.tapp-dex.devucc.name/api/v1",
  sorContractAddress:
    "0xe34cea371eff04b98a8007ce14e5b8ee767602857547a35a48a6ecc0d91847c2",
};

const MAINNET_CONFIG: SDKConfig = {
  network: Network.MAINNET,
  contractAddress:
    "0x487e905f899ccb6d46fdaec56ba1e0c4cf119862a16c409904b8c78fab1f5e8a",
  url: "https://api.tapp.exchange/api/v1",
  sorContractAddress:
    "0x7bd64a730c360a87da24187d6d2e9128310ff25419facb3000d6b2293a06280a",
};

export const initTappSDK = (initConfig?: InitTappSDKConfig) => {
  const config =
    initConfig?.network == Network.TESTNET ? TESTNET_CONFIG : MAINNET_CONFIG;

  return new TappSDK({
    network: config.network,
    url: initConfig?.url ?? config.url,
    contractAddress: config.contractAddress,
    sorContractAddress: config.sorContractAddress
  });
};
